import React from "react";
import { jsx } from "slate-hyperscript";
import {
    InlineHandler, StyleType,
} from "./base";

InlineHandler.register(StyleType.BOLD, {
    nodeTypes: ["STRONG", "B"],
    toBlock: child => <strong>{child}</strong>,
    serialize: child => `<strong>${child}</strong>`,
    deserialize: current => jsx("text", { ...current, [StyleType.BOLD]: Object.create(null) }),
});
